/**
 * Migrated from:
 * nm/mvc/ValidatedAddressMixin.js
 */
export const ValidatedAddressMixin = {
  address1Rule() {
    const country = $('*[name="tx_project_contestapplication[contestApplicationFormData][country]"]').val(); // TODO: Updated for TYPO3
    if (country === 'at') {
      return ['street_at'];
    } else {
      return ['street_de'];
    }
  },

  zipRule() {
    const country = $('*[name="tx_project_contestapplication[contestApplicationFormData][country]"]').val(); // TODO: Updated for TYPO3
    if (country === 'de') {
      return ['zip_de'];
    } else if (country === 'at') {
      return ['zip_at'];
    } else if (country === 'nl') {
      return ['zip_nl'];
    } else {
      return [];
    }
  },

  cityRule() {
    return 'city';
  },
};
